import React from "react";
import SettingsPage from "../../../components/List/SettingsList"
import { useTranslation } from "react-i18next";

const ProgramSettingsPage: React.FC = () => {
    const { t } = useTranslation();

   
    return (
        <SettingsPage
            title={t("common.program")}
            fetchUrl= "/itemApi/GetProgramList"
            createOrUpdateUrl= "itemApi/CreateOrUpdateProgram"
            deleteUrl= "itemApi/DeleteProgram"
        
        />
    );
};

export default ProgramSettingsPage;
